import { Palette, Ear, Brain } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const APPROACHES = [
  {
    icon: Palette,
    title: "Play Therapy",
    audience: "For children",
    desc: "Children speak through play long before they speak in words. Toys, stories, art and games become a safe way for your child to express big feelings and practise new skills.",
  },
  {
    icon: Ear,
    title: "Client-Centred Therapy",
    audience: "For teens & adults",
    desc: "You set the pace and the topics. I listen without judgement, and together we uncover the answers you already carry — my job is to help you hear them.",
  },
  {
    icon: Brain,
    title: "CBT",
    audience: "For teens & adults",
    desc: "Cognitive Behavioural Therapy gently spots the thought loops that feed anxiety, stress and self-doubt — then rewires them with small, practical exercises that fit real life.",
  },
];

export default function Approaches() {
  return (
    <section id="approaches" data-testid="approaches-section" className="bg-[#ECFDF5]/60 py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
        <Reveal className="mb-12 max-w-2xl lg:mb-16">
          <Eyebrow>How I work</Eyebrow>
          <h2 className="mt-4 font-serif text-3xl font-medium leading-snug tracking-tight text-[#064E3B] sm:text-4xl lg:text-5xl">
            Different minds need <em className="text-[#059669]">different doors</em> in
          </h2>
          <p className="mt-4 text-base text-[#526560]">
            No jargon, no one-size-fits-all. Here is what happens in a session, in plain words.
          </p>
        </Reveal>
        <div className="grid grid-cols-1 gap-6 md:grid-cols-3 lg:gap-8">
          {APPROACHES.map((a, i) => (
            <Reveal key={a.title} delay={i * 0.1}>
              <div
                data-testid="approach-card"
                className="group h-full rounded-3xl border border-[#064E3B]/12 bg-[#FFFDF9] p-7 transition-transform duration-300 hover:-translate-y-1.5 hover:shadow-[0_18px_40px_-18px_rgba(6,78,59,0.3)] sm:p-8"
              >
                <div className="flex items-center justify-between">
                  <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-[#064E3B] text-[#FDFBF7]">
                    <a.icon size={22} />
                  </span>
                  <span className="rounded-full bg-[#ECFDF5] px-3 py-1 text-[11px] font-bold uppercase tracking-[0.12em] text-[#059669]">
                    {a.audience}
                  </span>
                </div>
                <h3 className="mt-5 font-serif text-xl font-medium text-[#064E3B] sm:text-2xl">{a.title}</h3>
                <p className="mt-2.5 text-sm leading-relaxed text-[#526560]">{a.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
